import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
// import GiftCard from "@/assets/gift_cards.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
// import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import Wifi from "@/assets/wifi.svg";
// import Share from "@/assets/coin.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
// import Banks from "@/assets/project-assets/banks.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Speciality from "@/assets/speciality-services.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";
// import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
// import ElectricScooter from "@/assets/project-assets/electric-scooter-station.svg";
import BikeParking from "@/assets/project-assets/bike-parking.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import ParkingPay from "@/assets/project-assets/pay-station.svg";
import LowEmissionParking from "@/assets/low-emission.svg";
import ValetParking from "@/assets/valet.svg";
import FamilyRoom from "@/assets/family.svg";
import SmallCarParking from "@/assets/small-car-parking.svg";
import Stroller from "@/assets/stroller.svg";
import PhoneCharging from "@/assets/key.svg";
import CosmeticsPerfume from "@/assets/perfume.svg";
import DepartmentStores from "@/assets/department-stores.svg";
import ToysGames from "@/assets/toys_&_games.svg";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      // {
      //   title: "banks-financial",
      //   iconImage: Banks,
      //   id: [
      //     "f916f3f4-247e-41a3-81ed-451f2a187915:ea8b00f4-d618-41ae-a194-36d8c2012d0c",
      //   ],
      //   type: "list",
      //   hideMapIcon: true,
      // },
      {
        title: "cosmetics-perfumes",
        iconImage: CosmeticsPerfume,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:b1814f55-9768-448f-8c98-d9d869b87156",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "department-stores",
        iconImage: DepartmentStores,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:a6268d3f-3210-4eb8-92c7-5ff97594c752",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-book-stores",
        iconImage: Electronics,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:9a63886b-e0d0-47d0-a7ec-2a978dc98b36",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:ffe35fff-4c3e-4752-b05e-a4082c4e3746",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:f418bd05-20a1-4404-b914-a0ae61ecc1f9",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:8fde237b-f45f-4d36-9081-13e9b41cf8f4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:74c53fd4-de76-47b8-b71c-9267f802e0d3",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:a3d4e085-8e4f-4136-97d0-4c8e4356df9b",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:52946674-c091-4cf8-a110-ebe601982749",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:9532ff13-6901-4171-98ce-8f4bd677752f",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:c92bab40-5cd6-4224-9c9e-b6b2af0827fe",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:aa724cca-deeb-49f5-a2da-e7cf95b77e82",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services-speciality",
        iconImage: Speciality,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:99a0a1c8-757b-4d36-97ac-08e607bc8128",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:ad138a68-b666-422f-8c1a-fdc301448b44",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "toys-childrens-interests",
        iconImage: ToysGames,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:3d1f630d-ed75-4018-8a28-9815b4423156",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes-specialty",
        iconImage: Cafe,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:85772844-8f4b-4e47-ae04-46b980c2aef8",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "food-court",
        iconImage: FastFood,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:2f0cedaf-6f8e-47f1-b8c5-e259d1320662",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:68a2bbb9-88e4-411c-8574-694bb2472830",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "be10bdce-cd82-4c67-8559-2e6b8e78d587:5ce8d16a-e795-4e2c-802c-083312db4d06",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:fb58eb76-7a88-4faf-a751-bb1d25db6e08",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:75c6fe1f-e4c9-440d-82a4-6adb20ee714a",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:c95045e4-fd84-46aa-87a9-e56b6f2d482a",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:c8f4e81e-da40-4573-a762-e7ec3f4226a6",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:d5f90617-c952-4ca3-8be7-02e5588a736a",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:1d0f66d1-2347-4a32-b304-a96a32f7a19b",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "family-room",
        iconImage: FamilyRoom,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:2191822f-4114-4ed3-8ec2-54cac0868b67",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:c95045e4-fd84-46aa-87a9-e56b6f2d482a",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:f856e626-a80f-45af-ac56-ead50212b8e2",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:c95045e4-fd84-46aa-87a9-e56b6f2d482a",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:1d6e56e7-c367-48bd-989d-84400a188d4c",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:b4289af6-39ae-4c63-8395-8b707cac331d",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:2652127a-2fc8-49e4-810f-18843cfa9046",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:ac40b3c5-b40e-404b-b74e-2bd48503cd1e",
        type: "closest",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:63554454-4908-4456-a7e6-dbe6d05c93ef",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:2ed2f6f0-6d90-4a3a-bce3-3309a2308f5e",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "low-emission-parking",
        iconImage: LowEmissionParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:bba978d5-ad21-4f28-a7f6-07c1dfcbcb7f",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "small-car-parking",
        iconImage: SmallCarParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:db2410d2-a770-422b-8606-f322a74a6716",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bike-parking",
        iconImage: BikeParking,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:f4398280-a6c3-4faa-ae7a-4cc993328880",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "parking-pay-station",
        iconImage: ParkingPay,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:8761a4ed-647a-496b-be7f-6bb3e7af4ab3",
        type: "info",
        listed: true,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:3da0c085-451c-4c25-aa05-1dd55e22199b",
        type: "list",
        listed: true,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:b6fcda00-ed76-4b39-b62f-e2b218cedb12",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:4d97ff8e-8c59-4de5-892a-56c7477dce7b",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:8e8a8d8c-b0c8-497c-a7c7-118642cf1bb2",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "baby-strollers",
        iconImage: Stroller,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:e52155d8-0d0a-49da-9b53-ded2ab34f71c",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "phone-charging",
        iconImage: PhoneCharging,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:1d0f66d1-2347-4a32-b304-a96a32f7a19b",
        type: "closest",
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideIconUntilSelected: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:bd14cc26-fcb8-4f4f-9c52-2b00e8f43cdf",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "f916f3f4-247e-41a3-81ed-451f2a187915:3ed28bd5-413b-42b2-93f6-691faa3be711",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:32eadeb2-461c-4075-ace2-fc362712579f",
          "f916f3f4-247e-41a3-81ed-451f2a187915:ec5b51fe-1817-44a0-8afa-8b5aa909624f",
          "f916f3f4-247e-41a3-81ed-451f2a187915:12c4c3da-265d-416f-a175-86abdfb9c740",
          "f916f3f4-247e-41a3-81ed-451f2a187915:8a173997-97f8-4c14-a0f7-0aa14907324c",
          "f916f3f4-247e-41a3-81ed-451f2a187915:62bfda24-d619-439a-adb1-1134e7dd10a2",
          "f916f3f4-247e-41a3-81ed-451f2a187915:1b246778-dbe9-4e1a-b9d4-8427af43511c",
          "f916f3f4-247e-41a3-81ed-451f2a187915:1db48d6a-c32c-4d27-91e4-ab1f7157bf2f",
          "f916f3f4-247e-41a3-81ed-451f2a187915:e4d2644c-ecc1-47ec-a735-23e8f3372e63",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:26c4225a-19a5-4ee4-b3e5-6bbf8d899f50",
          "f916f3f4-247e-41a3-81ed-451f2a187915:1763c1d2-0366-47f6-8290-a829f317faa0",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:29281440-6224-4ee3-82c0-b48c79190af2",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "parking",
        id: [
          "f916f3f4-247e-41a3-81ed-451f2a187915:0f4cf6b2-fb4d-4771-af4e-618eda1296e8",
        ],
        type: "list",
        listed: true,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      // {
      //   title: "share",
      //   iconImage: Share,
      //   type: "info",
      //   listed: false,
      //   content: {
      //     en: `
      // 			<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
      // 			<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
      // 			<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
      // 			<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
      // 		`,
      //     ar: `
      // 		<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
      // 		<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
      // 		<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
      // 		<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
      // 		`,
      //   },
      // },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
